<template functional>
  <div
    :class="$options.methods.mergeFunctionalRenderContextClasses(data)"
    v-bind="data"
  >
    <div
      v-if="!props.withoutTitle"
      class="px-4 py-3 text-white bg-gray-700"
    >
      <slot
        name="title"
        :title="props.title"
      >
        {{ props.title }}
      </slot>
    </div>

    <div
      v-show="! props.isCollapsed"
      :class="{
        'border-l border-r border-gray-700': !props.seamless,
        'border-b': !props.seamless && ! $slots.controls
      }"
    >
      <slot />
    </div>

    <div
      v-if="!! $slots.controls && ! props.isCollapsed"
      class="flex justify-end p-4 bg-gray-200"
      :class="{ 'border border-t-0 border-gray-700': !props.seamless }"
    >
      <slot name="controls" />
    </div>
  </div>
</template>

<script>
import { mergeFunctionalRenderContextClasses } from '@/helpers/utils'

export default {
  name: 'MiaPanel',

  props: {
    title: {
      type: String,
      default: ''
    },

    isCollapsed: {
      type: Boolean,
      default: false
    },

    withoutTitle: {
      type: Boolean,
      default: false
    },

    seamless: {
      type: Boolean,
      default: false
    }
  },

  methods: {
    mergeFunctionalRenderContextClasses
  }
}
</script>
